import { FilePrefix } from "../../types";
import { AUDIO_SIZE_LIMIT, IMAGE_SIZE_LIMIT, VIDEO_SIZE_LIMIT, VRM_SIZE_LIMIT } from "../constants";

/**
 * 驗證檔案大小
 * @throws Error 如果檔案超過大小限制
 */
export function validateFileSize(file: File, prefix: FilePrefix): void {
    const limit = {
        image: IMAGE_SIZE_LIMIT,
        video: VIDEO_SIZE_LIMIT,
        audio: AUDIO_SIZE_LIMIT,
        vrm: VRM_SIZE_LIMIT,
    }[prefix];
    if (file.size > limit) {
        const limitMB = (limit / (1024 * 1024)).toFixed(0);
        const fileMB = (file.size / (1024 * 1024)).toFixed(2);
        throw new Error(`檔案大小 ${fileMB}MB 超過 ${limitMB}MB 限制`);
    }
}
